/**
 * ExportButtons - Row of CSV/PDF/PNG export buttons
 * @module wellRegistrationTotals/components/molecules/ExportButtons
 */

import React from "react";
import { Button, Box } from "@material-ui/core";
import { CSVLink } from "react-csv";
import GetAppIcon from "@material-ui/icons/GetApp";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import ImageIcon from "@material-ui/icons/Image";

/**
 * Export buttons group (CSV, PDF, PNG)
 * @param {Object} props
 * @param {Array} props.csvData - Data for CSV export
 * @param {string} props.csvFilename - Filename for CSV download
 * @param {Function} props.onPrint - PDF print handler
 * @param {Function} props.onPngExport - PNG export handler
 * @param {boolean} [props.disabled=false] - Whether buttons are disabled
 * @param {string} [props.size="small"] - Button size
 * @param {string} [props.variant="outlined"] - Button variant
 */
const ExportButtons = React.memo(
  ({
    csvData,
    csvFilename,
    onPrint,
    onPngExport,
    disabled = false,
    size = "small",
    variant = "outlined",
  }) => (
    <Box display="flex">
      <Button
        variant={variant}
        color="primary"
        size={size}
        startIcon={<GetAppIcon />}
        component={CSVLink}
        data={csvData}
        filename={csvFilename}
        disabled={disabled}
        style={{ marginRight: 8 }}
      >
        CSV
      </Button>
      <Button
        variant={variant}
        color="primary"
        size={size}
        startIcon={<PictureAsPdfIcon />}
        onClick={onPrint}
        disabled={disabled}
        style={{ marginRight: 8 }}
      >
        PDF
      </Button>
      <Button
        variant={variant}
        color="primary"
        size={size}
        startIcon={<ImageIcon />}
        onClick={onPngExport}
        disabled={disabled}
      >
        PNG
      </Button>
    </Box>
  )
);

ExportButtons.displayName = "ExportButtons";

export default ExportButtons;
